export type BlogCategory = {
  slug: 'ai-tech' | 'freelance' | 'career' | 'market' | 'development'
  cmsLabel: string
  tabLabel: string
  seoTitle: string
  seoDescription: string
  cardCharacterSrc: string
}

export const blogCategories: readonly BlogCategory[] = [
  {
    slug: 'ai-tech',
    cmsLabel: 'AI・テクノロジー',
    tabLabel: 'AI・テクノロジー',
    seoTitle: 'AI・テクノロジーの記事一覧',
    seoDescription:
      'AIや最新テクノロジーに関する、フリーランスエンジニア向けの記事一覧です。技術トレンドや実務に役立つ情報を紹介します。',
    cardCharacterSrc: '/2_12.png',
  },
  {
    slug: 'freelance',
    cmsLabel: 'フリーランス',
    tabLabel: 'フリーランス',
    seoTitle: 'フリーランスの記事一覧',
    seoDescription:
      'フリーランスエンジニアの働き方や独立、案件探しに役立つ記事一覧です。活動を支える実践的な情報を紹介します。',
    cardCharacterSrc: '/2_06.png',
  },
  {
    slug: 'career',
    cmsLabel: 'キャリア・転職',
    tabLabel: 'キャリア・転職',
    seoTitle: 'キャリア・転職の記事一覧',
    seoDescription:
      'エンジニアのキャリア設計や転職に役立つ記事一覧です。スキルを生かした働き方やキャリア形成の情報を紹介します。',
    cardCharacterSrc: '/1_02.png',
  },
  {
    slug: 'market',
    cmsLabel: 'IT業界・市場動向',
    tabLabel: 'IT業界・市場動向',
    seoTitle: 'IT業界・市場動向の記事一覧',
    seoDescription:
      'IT業界やフリーランス市場の動向に関する記事一覧です。案件選びやキャリア設計に役立つ最新情報を紹介します。',
    cardCharacterSrc: '/1_07.png',
  },
  {
    slug: 'development',
    cmsLabel: '開発・技術',
    tabLabel: '開発・技術',
    seoTitle: '開発・技術の記事一覧',
    seoDescription:
      '開発手法やエンジニアスキルの向上に役立つ記事一覧です。現場で活用できる技術知識や学習情報を紹介します。',
    cardCharacterSrc: '/2_11.png',
  },
]

export const getBlogCategoryByCmsLabel = (
  cmsLabel?: string | null,
): BlogCategory | undefined =>
  blogCategories.find((category) => category.cmsLabel === cmsLabel?.trim())

export const getBlogCategoryBySlug = (
  slug?: string | null,
): BlogCategory | undefined =>
  blogCategories.find((category) => category.slug === slug)
